import React from "react";
import "./css/dashboard.css";
import axios from "axios";
import {API_URI, PAYMENT_METHODS, MEMBERSHIP_FEE_CENTS} from "../../constant/Config";
import {t} from '../../constant/i18n';
import {formatPrice} from '../../constant/currency';
import {THEME} from '../../constant/theme';
import {
    Typography,
    Divider,
    Timeline,
    Space,
    Alert,
    Button,
    Select,
    Radio,
    Collapse,
    Popconfirm,
    message,
    Result
} from 'antd';
import {ClockCircleOutlined, SmileOutlined} from '@ant-design/icons';

const {Title, Paragraph, Text, Link} = Typography;
const {Panel} = Collapse;
const {Option} = Select;

class OrderDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            dataCmd: false,
            dataForm: false,
            zone1: false,
            statut: false,
            soldeDu: 0,
        }
    }

    async componentDidMount() {

        if (PAYMENT_METHODS.includes('lcl')) {
            await this.getFormCb();
        }
        const dataCMD = await this.getDetailsCmd();

        // ancien calcul du solde à suprimer
        //var soldeDu = dataCMD.data.totalht - 200;

        // récupération du solde en déduisant les transactions déjà payées
        var soldeDu = dataCMD.soldeApayer;


        await this.setState({
            dataCmd: dataCMD,
            statut: parseInt(dataCMD.data.gpCommandescolStatut),
            zone1: this.stepDisplay(),
            soldeDu: soldeDu,
        })
        const displayStep = this.stepDisplay();
        await this.setState({
            zone1: displayStep,
        })

        console.log(this.state.statut)

    }

    getDetailsCmd = async () => {
        var token = localStorage.getItem('membre_token');
        let dataCmd = await axios.post(API_URI + '/api_member/details_order', {
            id: this.state.id,
        }, {
            headers: {
                'Authorization': token
            }
        })
        return dataCmd.data;
    }

    getFormCb = async () => {
        const formPayement = await axios.post(API_URI + '/api_member/payment', {id: this.state.id});
        await this.setState({dataForm: formPayement.data.data});
    }

    validePayement = async (typePayement, amount) => {
        const paramPost = {
            idCmd: this.state.id,
            setPaymentMeans: '',
            setCardNumber: '',
            setAmount: (amount),
            setTypepaiement: typePayement,
            setEtat: '0',
            setEtatAuto: '0',
            setGpTransactionNum: '',
        }
        const formPayement = await axios.post(API_URI + '/api_member/payment-validation', paramPost);
        await this.setState({zone1: this.confirmationPayement(typePayement)})
    }

    validePayementStripe = async () => {
        try {
            const res = await axios.post(API_URI + '/api_member/stripe/create-session', {
                id: this.state.id,
            });
            if (res.data && res.data.response === 'yes' && res.data.data && res.data.data.url) {
                window.location.href = res.data.data.url;
            } else {
                message.error(t('orderDashboard.stripeInitError'));
            }
        } catch (e) {
            message.error(t('orderDashboard.stripeConnectError'));
        }
    }

    validePayementMobilepay = async () => {
        try {
            const res = await axios.post(API_URI + '/api_member/vipps/create-session', {
                id: this.state.id,
            });
            if (res.data && res.data.response === 'yes' && res.data.data && res.data.data.url) {
                window.location.href = res.data.data.url;
            } else {
                message.error(t('orderDashboard.mobilepayInitError'));
            }
        } catch (e) {
            message.error(t('orderDashboard.mobilepayConnectError'));
        }
    }

    createMarkup = (html) => {
        return {__html: html};
    }

    modulePayement = (amount, type) => {
        if (this.state.dataForm) {
            var formCB = <div dangerouslySetInnerHTML={this.createMarkup(this.state.dataForm)}/>
        } else {
            var formCB = t('common.loading');
        }

        if (type == 'prempaiement') {

            // déterminer si c'est une commande membre honoraire (premiere comande ou non)

            if (this.state.dataCmd.data.gpCommandescolWfCotisation == 1) {
                var title = <div>{t('orderDashboard.actionRequired')}</div>
                var msg = <div>
                    <p>{t('orderDashboard.cotisationHappy')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.cotisationP1')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.cotisationP2')}</p>
                    {t('orderDashboard.thirdPartyQuestion')}<br/>
                    {t('orderDashboard.thirdPartyIntro')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption1')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption2')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption3')}<br/><br/>

                    <br/>
                    <p>{t('orderDashboard.processingDelay')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.contactHelp')} <a target="_blank"
                                                                                                   href={THEME.urls.appointment}>{t('orderDashboard.contactHelpLink')}</a></p>
                </div>
            } else {
                var title = <div>{t('orderDashboard.actionRequired')}</div>
                var msg = <div>
                    <p>{t('orderDashboard.cotisationHappy')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.acompteP1')}</p>

                    {t('orderDashboard.thirdPartyQuestion')}<br/>
                    {t('orderDashboard.thirdPartyIntro')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption1')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption2')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption3')}<br/><br/>

                    <br/>


                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.acompteP2')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.cotisationP2')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.processingDelay')}</p>
                    <p>&nbsp;</p>
                    <p>{t('orderDashboard.contactHelp')} <a target="_blank"
                                                                                                   href={THEME.urls.appointment}>{t('orderDashboard.contactHelpLink')}</a></p>
                </div>
            }

            var message = <Alert
                message={title}
                description={msg}
                type="warning"
                showIcon
                closable
            />
        } else if (type == 'solde') {

            if (this.state.dataCmd.data.idCat == 3) {
                // ne pas afficher le message pour les prgrammes langues
                var description = <></>;
            } else {
                var description = <div>
                    {t('orderDashboard.soldePay', {amount: formatPrice(amount / 100)})} <br/><br/>

                    {t('orderDashboard.thirdPartyQuestion')}<br/>
                    {t('orderDashboard.thirdPartyIntro')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption1')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption2')}<br/><br/>

                    {t('orderDashboard.thirdPartyOption3')}<br/><br/>

                    <br/>
                </div>
            }

            var message = <Alert
                message={t('orderDashboard.actionRequiredSolde')}
                description={description}
                type="warning"
                showIcon
                closable
            />
        }


        return <div>
            <Space direction="vertical">
                <div>
                    {message}
                </div>
                <Collapse accordion defaultActiveKey={[PAYMENT_METHODS[0]]}>
                    {PAYMENT_METHODS.includes('lcl') &&
                    <Panel header={t('orderDashboard.lclPayment')} key="lcl">
                        <div>
                            {t('orderDashboard.lclPaymentDesc')}
                        </div>
                        <div>{formCB}</div>
                    </Panel>}
                    {PAYMENT_METHODS.includes('stripe') &&
                    <Panel header={t('orderDashboard.stripePayment')} key="stripe">
                        <div>
                            <div>
                                {t('orderDashboard.stripePaymentDesc')}
                            </div>
                            <br/>
                            <Button type="primary" onClick={this.validePayementStripe}>
                                {t('orderDashboard.payWithStripe')}
                            </Button>
                        </div>
                    </Panel>}
                    {PAYMENT_METHODS.includes('mobilepay') &&
                    <Panel header={t('orderDashboard.mobilepayPayment')} key="mobilepay">
                        <div>
                            <div>
                                {t('orderDashboard.mobilepayPaymentDesc')}
                            </div>
                            <br/>
                            <Button type="primary" onClick={this.validePayementMobilepay}>
                                {t('orderDashboard.payWithMobilepay')}
                            </Button>
                        </div>
                    </Panel>}
                    {PAYMENT_METHODS.includes('wire') &&
                    <Panel header={t('orderDashboard.wireTransfer')} key="wire">
                        <div>
                            <div>
                                {t('orderDashboard.wireTransferDesc')}
                                <br/><br/>
                                {t('orderDashboard.wireTransferWarning')}
                                <br/><br/>
                                {t('orderDashboard.wireTransferConfirm')}

                            </div>
                            <br/>
                            <Popconfirm placement="right" title={t('common.confirmChoice')}
                                        onConfirm={() => this.validePayement('virement', amount)} okText={t('common.validate')}
                                        cancelText={t('common.cancel')}>
                                <Button type="primary">{t('orderDashboard.validateWireTransfer')}</Button>
                            </Popconfirm>
                        </div>
                    </Panel>}
                    {PAYMENT_METHODS.includes('check') &&
                    <Panel header={t('orderDashboard.checkPayment')} key="check">
                        <div>
                            <div>
                                {t('orderDashboard.checkPaymentDesc1')}<br/>
                                {t('orderDashboard.checkPaymentDesc2')}<br/>
                                <br/>
                                <Text strong>
                                    {t('orderDashboard.checkPaymentWarning')}
                                </Text>
                            </div>
                            <br/>
                            <Popconfirm placement="right" title={t('common.confirmChoice')}
                                        onConfirm={() => this.validePayement('cheque', amount)} okText={t('common.validate')}
                                        cancelText={t('common.cancel')}>
                                <Button type="primary">{t('orderDashboard.validateCheckPayment')}</Button>
                            </Popconfirm>
                        </div>
                    </Panel>}
                </Collapse>
            </Space>
        </div>
    }

    reloadStep = () => {
        console.log(this.state.statut)
        this.setState({
            zone1: this.stepDisplay()
        })

    }

    handleChange = async (value) => {
        await await axios.post(API_URI + '/api_member/update-order-statut', {id: this.state.id, statut: value});
        await this.setState({statut: value})
        await this.setState({zone1: this.stepDisplay()})
    }

    confirmationPayement = (typePayement) => {

        // mise à jour du statut après paiement
        this.setState({
            statut: this.state.statut + 1,
        })

        if (typePayement == 'virement') {
            var title = <div>{t('orderDashboard.paymentPending')}</div>
            var msg = <div>
                {t('orderDashboard.thanksPayment')}<br/><br/>

                {t('orderDashboard.uponReception')}<br/><br/>

                <div style={{color: "#b81556", textAlign: "center"}}>{t('orderDashboard.wireTransferTitle')}</div>
                <br/><br/>

                <b>{t('orderDashboard.notDirectDebitPrefix')}</b> {t('orderDashboard.notDirectDebit')}

                <br/><br/>
                <table border="2" style={{borderCollapse: "collapse", borderColor: "#b81556", width: "100%"}}>
                    <tr>
                        <th>{t('orderDashboard.bankColumn')}</th>
                        <th>{t('orderDashboard.codeColumn')}</th>
                        <th>{t('orderDashboard.accountColumn')}</th>
                        <th>{t('orderDashboard.ribKey')}</th>
                        <th>{t('orderDashboard.domiciliation')}</th>
                    </tr>
                    <tr>
                        <td>{THEME.bank.bankCode}</td>
                        <td>{THEME.bank.branchCode}</td>
                        <td>{THEME.bank.accountNumber}</td>
                        <td>{THEME.bank.ribKey}</td>
                        <td>{THEME.bank.branch}</td>
                    </tr>
                </table>

                <br/><br/>

                <i>{t('orderDashboard.accountHolder')}</i> <b>{THEME.bank.name}</b>
                <br/>
                <strong>
                    {t('orderDashboard.intlIdent')}<br/>
                    IBAN : {THEME.bank.iban}<br/>
                    Code B.I.C : {THEME.bank.bic}
                </strong>
                <br/><br/>
                {t('orderDashboard.wireLabel')}
                <br/><br/>
                {t('orderDashboard.bankFees')}
                <br/><br/>
                {t('orderDashboard.contactByEmail')} <a
                href={'mailto:' + THEME.email}>{THEME.email}</a>
            </div>
        } else if (typePayement == 'cheque') {
            var title = <div>{t('orderDashboard.paymentPending')}</div>
            var msg = <div>
                {t('orderDashboard.thanksPayment')}<br/><br/>

                {t('orderDashboard.uponReception')}<br/><br/>

                <div style={{color: "#b81556", textAlign: "center"}}>{t('orderDashboard.checkTitle')}
                </div>
                <br/><br/>

                {t('orderDashboard.checkInstruction')}
                <br/><br/>
                <strong>{t('orderDashboard.assocAddressLine1')}<br/>
                    {t('orderDashboard.assocAddressLine2')}<br/>
                    {t('orderDashboard.assocAddressLine3')}</strong>
                <br/><br/>

                {t('orderDashboard.checkOriginWarning')}

                <br/><br/>

                {t('orderDashboard.markName')}
                <br/><br/>
                {t('orderDashboard.contactByEmail')} <a
                href={'mailto:' + THEME.email}>{THEME.email}</a>
            </div>
        }


        return <div>
            <Result
                status="success"
                title={title}
                subTitle={msg}
                extra={[
                    <Button type="primary" key="console" onClick={this.reloadStep}>
                        {t('orderDashboard.backToSteps')}
                    </Button>,
                ]}
            />
        </div>
    }

    stepDisplay = () => {

        var zonePaiement1 = t('orderDashboard.cotisationOrAcompte');

        if (this.state.statut == 4) {
            var zonePaiement1 = <div>
                {t('orderDashboard.cotisationOrAcompte')} : <br/>
                <div>{this.modulePayement(MEMBERSHIP_FEE_CENTS, 'prempaiement')}</div>
            </div>;
        }

        var zonePaiement2 = t('orderDashboard.remainingBalance');

        if (this.state.statut == 7) {
            var zonePaiement2 = <div>
                {t('orderDashboard.remainingBalance')} : <br/>
                <div>{this.modulePayement((this.state.soldeDu * 100), 'solde')}</div>
            </div>;
        }

        return <div>
            <Timeline>
                <Timeline.Item color={(this.state.statut == 11) ? 'green' : 'gray'}>{t('orderDashboard.applicationToComplete')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 2) ? 'green' : 'gray'}>{t('orderDashboard.applicationInReview')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 3) ? 'green' : 'gray'}>{t('orderDashboard.applicationAccepted')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 4) ? 'green' : 'gray'}>{zonePaiement1}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 5) ? 'green' : 'gray'}>{t('orderDashboard.cotisationPendingValidation')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 6) ? 'green' : 'gray'}>{t('orderDashboard.firstPaymentValidated')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 7) ? 'green' : 'gray'}>{zonePaiement2}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 8) ? 'green' : 'gray'}>{t('orderDashboard.balancePendingValidation')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 9) ? 'green' : 'gray'}>{t('orderDashboard.balanceValidated')}</Timeline.Item>
                <Timeline.Item color={(this.state.statut == 10) ? 'green' : 'gray'}>{t('orderDashboard.projectFinalized')}</Timeline.Item>
            </Timeline>
        </div>
    }

    render() {

        if (this.state.dataCmd) {
            return (
                <div>
                    <Space direction="vertical">
                        <Title level={3}>{t('orderDashboard.mySteps')}</Title>
                        <Paragraph>
                            {t('orderDashboard.registrationStatus')}
                        </Paragraph>

                        <br/>


                        {this.state.zone1}

                    </Space>
                </div>
            );
        } else {
            return <div></div>
        }


    }
}

export default OrderDashboard;